module.exports = __webpack_public_path__ + "static/video_smallbanner-ed909a22d545add0ce7829972693b03d.png";